(function () {
  'use strict';

  angular.module('eclipseApp.myAccount').factory('onlineBillingService', onlineBillingService);

  onlineBillingService.$inject = ['commonService', 'uteModal', '$rootScope', 'uteEndpoint', '$http'];

  /* @ngInject */
  function onlineBillingService(commonService, uteModal, $rootScope, uteEndpoint, $http) {

    var subscribers = [];
    var paperBillingData;
    var emailList;
    var accountCount = 0;
    var showLegacyWidget;
    var captureEmail;

    /* After refactoring commonService to get accountDetails async, this function should be removed*/
    function init(accountDetails) {
      paperBillingData = [];
      emailList = [];
      _.each(accountDetails, function (accountDetail) {
        if ((accountDetail.billingType) && (accountDetail.LOB) && (accountDetail.billingType.toLowerCase() === 'paper') && (accountDetail.LOB.toLowerCase() !== 'wlpp')) {
          if (accountDetail.contactEmail) {
            emailList.push(accountDetail.contactEmail);
          }
          accountCount++;
          var paperBilling = {};
          paperBilling.accountNumber = accountDetail.accountNumber;
          paperBilling.hasWireless = accountDetail.hasWireless;
          paperBillingData.push(paperBilling);
        }
      });

      var uniqEmailList = _.uniq(emailList);

      if (accountCount === 0 && emailList.length === 0) { // All account are in online bill
      } else if (accountCount >= emailList.length && (uniqEmailList.length === 1 || uniqEmailList.length === 0)) { // All paper bill account has same Email ID/No Email
        showLegacyWidget = false;
        if (emailList.length >= 1) {
          captureEmail = emailList[0];
        }
      } else if (accountCount >= emailList.length && uniqEmailList.length > 1) { // Multi BAN account, some account with different/No email ID
        showLegacyWidget = true;
        paperBillingData = [];

        _.each(accountDetails, function (accountDetail) {
          if ((accountDetail.billingType) &&
            (accountDetail.LOB) &&
            (($rootScope.userInfo.profileType.ctn && accountDetail.contactEmail) || !$rootScope.userInfo.profileType.ctn) &&
            (accountDetail.billingType.toLowerCase() === 'paper') &&
            (accountDetail.LOB.toLowerCase() !== 'wlpp')) {
            var paperBilling = {};
            paperBilling.accountNumber = accountDetail.accountNumber;
            paperBilling.hasWireless = accountDetail.hasWireless;
            paperBillingData.push(paperBilling);
          }
        });
      }
    }

    function onlineBillingPopUp(actionType) {
      uteModal.open({
        controller: 'learnMoreOnlineBillingCtrl',
        templateUrl: 'modules/my-account/overview/learn-more-online-billing.html',
        backdrop: 'static',
        keyboard: true,
        data: {
          'paperBillingCount': commonService.loadBillingDetails(),
          'paperBillingData': paperBillingData,
          'actionType': actionType, //'LearnMore', 'SwitchNow'
          'legacyWidget': showLegacyWidget,
          'customerEmail': captureEmail

        },
        ok: function () {
          console.log('OK');
        },
        cancel: function () {
          console.log('CANCEL');
        }
      });
    }

    function subscribeCallback(callback, id) {
      if (callback && id) {
        var found = _.find(subscribers, {id: id});
        if (found) {
          found.callback = callback;
        } else {
          subscribers.push({callback: callback, id: id});
        }
        return true;
      } else {
        return false;
      }
    }

    function unsubscribeCallback(id) {
      subscribers = subscribers.filter(function (object) {
        return object.id !== id;
      });
      return true;
    }

    function notifySubscribers() {
      subscribers.forEach(function (handler) {
        try {
          handler.callback();
        } catch (e) {
          console.error(e);
        }
      });
    }

    function switchBillingType(accountList, email) {
      return $http({
        url: uteEndpoint('v1/update/customer/billing/media'),
        method: 'POST',
        data: {
          lAccountNumber: accountList,
          emailId: email
        }
      }).then(function (response) {
        var data = response.data;
        // chances are, we get error even with http/200 in this API!
        if (data && ((!_.isArray(data) && !data.error) || (_.isArray(data) && _.every(data, 'error', '')))) {
          notifySubscribers();
        }
        return data;
      });
    }


    return {
      init: init,
      onlineBillingPopUp: onlineBillingPopUp,
      switchBillingType: switchBillingType,
      subscribeCallback: subscribeCallback,
      unsubscribeCallback: unsubscribeCallback
    };

  }

})();
